export const bugsnagApiKey = '6395b9e67d45821ff4a0f8511fffa6dd';